import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio as MuiRadio,
  RadioGroup,
} from '@mui/material';
import { Controller, ControllerProps } from 'react-hook-form';

export type Option = {
  value: string | number;
  label: string;
  labelComponent?: JSX.Element;
};

export interface RadioProps extends Omit<ControllerProps, 'render'> {
  label?: string;
  disabled?: boolean;
  options: Option[];
  direction?: 'row' | 'column';
}

export const Radio = ({
  direction = 'column',
  label,
  disabled = false,
  options,
  ...props
}: RadioProps) => {
  const labelId = `${props.name}-label`;
  return (
    <Controller
      {...props}
      rules={!disabled ? props.rules : undefined}
      render={({ field, fieldState: { error } }) => (
        <FormControl
          component="fieldset"
          error={!!error}
          disabled={disabled}
          className="w-full"
        >
          {label && (
            <FormLabel
              id={labelId}
              component="legend"
              className="ml-6 mb-1 font-bold"
              sx={{ color: 'black' }}
            >
              {label}
              {props.rules?.required && !disabled && (
                <span className="ml-1 text-mui-error">*</span>
              )}
            </FormLabel>
          )}
          <RadioGroup
            {...field}
            {...(label
              ? { 'aria-labelledby': labelId }
              : { 'aria-label': props.name })}
            row={direction === 'row'}
          >
            {options.map((option) => (
              <div
                key={option.value}
                className="ml-2 gap-2 flex items-start pt-2"
              >
                <FormControlLabel
                  control={<MuiRadio />}
                  value={option.value}
                  label={option.label}
                  disabled={disabled}
                />
                {option.labelComponent}
              </div>
            ))}
          </RadioGroup>
          {error && (
            <FormHelperText id={`${labelId}-helperText`}>
              {error.message}
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
};
